import React, { useState } from "react";
import "./mailbox.css";
import Sentbox from "./Sentbox";
import Inbox from "./Inbox";
import { FaHeart, FaEnvelope } from "react-icons/fa";

const Mailbox = () => {
  const [activeTab, setActiveTab] = useState("accepting");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="modern-mailbox-container">
      <div className="modern-mailbox-background">
        <div className="decorative-shape shape-1"></div>
        <div className="decorative-shape shape-2"></div>
        <div className="decorative-shape shape-3"></div>
      </div>
      
      <div className="modern-mailbox-content">
        <div className="modern-mailbox-header">
          <h2>Your Connections</h2>
          <p>Manage your interactions with other members</p>
        </div>
        
        <div className="modern-mailbox-tabs">
          <button
            className={`modern-tab-button ${activeTab === "accepting" ? "active" : ""}`}
            onClick={() => handleTabClick("accepting")}
          >
            <FaHeart className="tab-icon" />
            <span>Admired by</span>
          </button>

          <button
            className={`modern-tab-button ${activeTab === "sent" ? "active" : ""}`}
            onClick={() => handleTabClick("sent")}
          >
            <FaEnvelope className="tab-icon" />
            <span>My Admires</span>
          </button>
        </div>
        
        <div className="modern-mailbox-main">
          {activeTab === "accepting" && <Inbox />}
          {activeTab === "sent" && <Sentbox />}
        </div>
      </div>
    </div>
  );
};

export default Mailbox;